import { createContext, useContext } from 'react';

// Auth-context + hook, losgetrokken van de AuthProvider-component zodat het
// provider-bestand alleen componenten exporteert (Vite fast refresh).
// Eigen e-mail/wachtwoord-auth. Het sessietoken staat in localStorage; identiteit
// + geclaimde transponders komen van /api/me. `login()` opent de inlog-modal (zo
// hoeven Header/TransponderView niet te wijzigen); de daadwerkelijke API-acties
// heten signIn/signUp/sendReset/resetPassword.
export const AuthContext = createContext({
  loading: true,
  loggedIn: false,
  user: null,
  preferences: null,
  transponders: [],
  owns: () => false,
  refresh: () => {},
  savePreferences: async () => ({ ok: false, error: 'Niet ingelogd' }),
  login: () => {},
  logout: () => {},
  signIn: async () => ({ ok: false }),
  signUp: async () => ({ ok: false }),
  sendReset: async () => ({ ok: false }),
  resetPassword: async () => ({ ok: false }),
  impersonating: false,
  impersonate: async () => ({ ok: false }),
  stopImpersonating: () => {},
});

export function useAuth() {
  return useContext(AuthContext);
}
